import React from 'react';
import LoadingState from './LoadingState';
import MenuPullingLoader from './MenuPullingLoader';
import type { SSETaskStatus } from '../../hooks/useSSETaskMonitor';
import ErrorModal from './ErrorModal';

interface GlobalLoadersProps {
  integrationLoading: boolean;
  menuLoading: boolean;
  menuStatus: SSETaskStatus;
  cloverError: string | null;
  hasError: boolean;
}

/**
 * Centralized component for managing all app-level loaders
 * 
 * Responsibilities:
 * - Display LoadingState during Clover OAuth integration
 * - Display MenuPullingLoader during menu pull process
 * - Keep loader logic separate from routing logic
 * 
 * @param integrationLoading - Whether Clover integration is in progress
 * @param menuLoading - Whether menu pull is active
 * @param menuStatus - Current menu pull status
 */
const GlobalLoaders: React.FC<GlobalLoadersProps> = ({
  integrationLoading,
  menuLoading,
  menuStatus,
  cloverError,
  hasError
}) => {
  console.log(cloverError, "cloverError");

  const errorTitle = cloverError ? 'Connection Issue' : 'Menu Not Available';
  const errorMessage = cloverError
    ? "We can't connect to Clover right now. Please try again."
    : "We can't load your menu right now. Please refresh and try again.";

  return (
    <>
      {/* Show LoadingState during Clover integration */}
      {integrationLoading && (
        <div className="min-h-screen flex items-center justify-center bg-black">
          <div className="text-center">
            {/* <LoadingState message="Connecting to Clover..." /> */}
            <p className="text-gray-200 mt-6 text-sm">
              Please wait while we set up your account...
            </p>
            <p className="text-gray-300 mt-2 text-xs">
              This may take a few moments
            </p>
          </div>
        </div>
      )}

      <MenuPullingLoader isVisible={menuLoading} status={menuStatus} />

      <ErrorModal
        isVisible={hasError}
        title={errorTitle}
        message={errorMessage}
        type={cloverError ? 'clover' : 'task'}
      />
    </>
  );
};

export default GlobalLoaders;
